module.exports = __webpack_public_path__ + "static/media/SparkasseRg.fa580000.ttf";